import React from 'react';

const IntroSection = () => {
  return (
    <section className="py-32 px-4 bg-black">
      <div className="max-w-4xl mx-auto text-center">
        {/* Label */}
        <p className="text-xs tracking-[0.3em] text-gold mb-8">
          OUR WORK
        </p>

        {/* Gold Divider */}
        <div className="w-16 h-px bg-gold mx-auto mb-12"></div>

        {/* Pull Quote / Statement */}
        <blockquote className="mb-16">
          <p className="text-3xl md:text-4xl font-light leading-relaxed text-white/90 italic mb-8">
            "The most important stories refuse to stay in one form."
          </p>
        </blockquote>

        {/* Context Statement */}
        <div className="max-w-3xl mx-auto space-y-6 text-lg text-white/70 font-light leading-relaxed">
          <p>
            Three mediums. One source. The same relentless interrogation of what 
            it means to be alive in a body, in relationship, in a world that 
            doesn't always make room for the whole of you.
          </p>
        </div>

        {/* Three Verticals */}
        <div className="mt-16 grid md:grid-cols-3 gap-8 max-w-3xl mx-auto">
          <div className="border-t border-white/10 pt-6">
            <h3 className="text-xs tracking-[0.2em] text-gold mb-3">BOOKS</h3>
            <p className="text-sm text-white/60 font-light">
              Paranormal romance that carries more truth than it announces
            </p>
          </div>
          <div className="border-t border-white/10 pt-6">
            <h3 className="text-xs tracking-[0.2em] text-gold mb-3">MUSIC</h3>
            <p className="text-sm text-white/60 font-light">
              Worship that meets the sacred in difficult places
            </p>
          </div>
          <div className="border-t border-white/10 pt-6">
            <h3 className="text-xs tracking-[0.2em] text-gold mb-3">THEATRE</h3>
            <p className="text-sm text-white/60 font-light">
              Work that changes the temperature of a room
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroSection;
